<template>
    <transition name="slide-fade">
    <s-form-group :id="id" v-if="schema.config[fieldName].show" :class="schema.config[fieldName].stateClass">
            <s-form-group :label="fieldLabel+schema.config[fieldName].domElements.requiredIndicator" :label-for="schema.config[fieldName].id">
                <s-form-textarea
                        :id="schema.config[fieldName].id"
                        :data-vv-as="fieldLabel"
                        :name="schema.config[fieldName].name"
                        :aria-required="schema.config[fieldName].validation.required"
                        :maxlength="schema.config[fieldName].maxlength"
                        v-validate="schema.config[fieldName].validation"
                        v-model="schema.fields[fieldName]">
                </s-form-textarea>
            </s-form-group>
            <span class="py-field-msg">{{ errors.first(fieldName) }}</span>
    </s-form-group>
    </transition>
</template>

<script>

    import sFormGroup from '../form/s-form-group'
    import sFormTextarea from '../form/s-form-textarea'
    import formHelpers from '../../utils/helpers/formHelpers'

    export default {
        name: 'sTextareaGroup',
        mixins: [formHelpers],
        props:{
            fieldName: String,
            label: String
        },
        data() {
          return {
              schema: this.$root.$data.schema,
              id: 'py-formGroup-'+this.fieldName,
              fieldLabel: (typeof this.label === "undefined") ? this.$i18n.t('message.fields.'+this.fieldName+'.label') : this.label
          }
        },
        inject: {
            $validator: '$validator'
        },
        components: {
            sFormTextarea,
            sFormGroup
        },
        mounted(){
            this.addEventListeners()
        }
    }

</script>

